<template>
  <div id="navbar-wrapper">
    <nav class="navbar is-fixed-top has-shadow" role="navigation">
      <div class="navbar-brand">
        <a class="navbar-item" :href="branding?.siteUrl">
          <img :src="`/branding/${$root.baseDomain}/logo.png`" alt="Logo">
        </a>

        <a
            role="button"
            class="navbar-burger"
            :class="{ 'is-active': menuOpen }"
            aria-label="menu"
            aria-expanded="false"
            data-target="navbar-menu"
            @click="toggleMenu"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbar-menu" class="navbar-menu" :class="{ 'is-active': menuOpen }">
        <div class="navbar-start">
          <router-link class="navbar-item" to="/api/v2" @click="onNavigate">API v2</router-link>
          <router-link class="navbar-item" to="/tokenization/" @click="onNavigate">Hosted Tokenization</router-link>

          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">Digital Wallets</a>
            <div class="navbar-dropdown">
              <router-link class="navbar-item" to="/digital-wallet/google-pay" @click="onNavigate">Google Pay</router-link>
              <router-link class="navbar-item" to="/digital-wallet/apple-pay" @click="onNavigate">Apple Pay</router-link>
            </div>
          </div>

          <router-link class="navbar-item" to="/webhooks" @click="onNavigate">Webhooks</router-link>
          <router-link v-if="isMainDomain" class="navbar-item" to="/pgp-public-key" @click="onNavigate">PGP Key</router-link>
          <router-link v-if="isMainDomain" class="navbar-item" to="/api/iso/v1" @click="onNavigate">Merchant Boarding API v1</router-link>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'navbar',
  props: {
    branding: { type: Object, default: () => ({}) },
    isMainDomain: { type: Boolean, default: false },
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    onNavigate() {
      this.menuOpen = false;
    },
  },
};
</script>
